import { render, staticRenderFns } from "./GoalsFilter.vue?vue&type=template&id=7097e3c2&"
import script from "./GoalsFilter.vue?vue&type=script&lang=js&"
export * from "./GoalsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports